import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class IsEmailAvailable {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService;

    /**
     * IsEmailAvailable constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_API_URL);
    }

    /**
     * Check if the email is available.
     *
     * @param {String} email
     *
     * @returns {Promise}
     */
    handle(email) {
        return this.apiService
            .post(ApiEndpoints['users.validate.email'], {
                email: email,
            });
    }
}
